import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class StripePaymentsService {

  constructor(private httpClient: HttpClient) { }


  createSession(packageId, productId, priceId, mode, successUrl, failedUrl, rouletteId, Useremail,paymentType) {
    const sessionData = {
      PackageId: packageId,
      ProductID: productId
      , PriceID: priceId
      , Mode: mode
      , SuccessUrl: `${window.location.origin}${successUrl}`
      , RouletteID: rouletteId
      , CancelUrl: `${window.location.origin}${failedUrl}`
      , UserEmail: Useremail
      ,PaymentType:paymentType
    };
    return this.httpClient.post<any>(`/stripe/createSession`, sessionData);
  }

  businessHasMethodPayment(): Observable<boolean> {
    return this.httpClient.get(`/stripe/businessHasMethodPayment`).pipe(map((res: any) => res.Result as boolean));
  }

}
